const menuItems = [
    { label: "Why me", href: "#stats" },
    { label: "Strategy", href: "#strategy" },
    { label: "Skills", href: "#skills" },
    { label: "Contact", href: "#contact" },
];

function Menu() {
    return (
        <div className="flex pl-4">
            <ul className="flex flex-col gap-1 text-gray-600 text-xs">
                {menuItems.map((item, index) => (
                    <li key={index}>
                        <a href={item.href} className="hover:text-gray-900 transition-colors">
                            {item.label}
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
}

function ProfileCard() {
    return (
        <div className="flex flex-col space-y-4 w-min">
            <div className="relative w-min">
                <div className="w-48 h-48 overflow-hidden">
                    <img
                        src="/profile-photo.jpg"
                        onError={(e) => {
                            (e.target as HTMLImageElement).src = "https://ui-avatars.com/api/?name=Manuel+Romero&background=100119&color=f0efe9&size=200";
                        }}
                        alt="Profile"
                        className="w-full h-full object-cover"
                    />
                </div>
            </div>

            <div>
                <h2 className="font-display uppercase text-3xl font-bold">Manuel Romero</h2>
                <p className="text-gray-600 max-w-sm text-xs">
                    I believe that code should not only work, it should be the invisible structure that supports great user experiences.
                </p>
            </div>
        </div>
    );
}

export function Hero() {
    return (
        <section className="py-16 w-full">
            <div className="flex flex-col lg:flex-row max-w-7xl mx-auto gap-12 items-start lg:items-center">
                {/* Left Side - Phrase */}
                <div className="space-y-6 w-full lg:w-2/3">
                    <h1 className="font-display uppercase text-[15vw]  md:text-9xl lg:text-9xl font-black leading-[0.85] w-full max-w-min">
                        Invisible Engineering Visible Results
                    </h1>
                </div>

                {/* Right Side - Profile & Menu */}
                <div className="flex flex-row items-start justify-end lg:justify-start gap-2 md:self-end lg:self-auto lg:space-y-4 lg:relative lg:top-[60px] w-full lg:w-1/3">
                    <ProfileCard />
                    <Menu />
                </div>
            </div>
        </section>
    );
}

export default Hero;
